module.exports = __webpack_public_path__ + "img/book.1c3cc771.svg";